export const getClassName = isLeftSectionShown => {
  return "ModalGroup" + (isLeftSectionShown ? "" : "--hidden_menu");
};
